import { render } from "./ClanChat.vue?vue&type=template&id=99119f48&scoped=true"
import script from "./ClanChat.vue?vue&type=script&lang=js"
export * from "./ClanChat.vue?vue&type=script&lang=js"

import "./ClanChat.vue?vue&type=style&index=0&id=99119f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99119f48"]])

export default __exports__